import { Phase } from '../atoms/reviewPricing.primitives.atoms'

export const duplicatePhase = ({ phase }: { phase: Phase }): Phase => {
  const newPhase: Phase = {
    ...phase,
    id: crypto.randomUUID(),
    name: phase.name ? `${phase.name} (Copy)` : undefined,
    /**
     * A new phase resets the billing periods by default - co-terming with the
     * previous phase is the explicit opt-out.
     */
    recurrencePreference: 'RESET'
  }

  return newPhase
}
